import { defineStore } from 'pinia'
import { ref } from 'vue'

// 定义服务状态存储
export const useServiceStore = defineStore('service', () => {
  // 通知公告状态
  const announcementList = ref([])
  const announcementDetail = ref(null)
  const announcementCount = ref(0)
  const unreadCount = ref(0)
  
  // 物业服务状态
  const propertyRepairList = ref([])
  const propertyRepairDetail = ref(null)
  const visitorAppointmentList = ref([])
  const visitorAppointmentDetail = ref(null)
  const facilityReservationList = ref([])
  const facilityReservationDetail = ref(null)
  
  // 通用状态
  const loading = ref(false)
  
  // 分页信息
  const announcementPagination = ref({
    total: 0,
    current: 1,
    pageSize: 10
  })
  
  // 过滤条件
  const announcementFilter = ref({
    type: null,
    keyword: '',
    startDate: null,
    endDate: null,
    page: 1,
    pageSize: 10
  })
  
  // 通知公告类型选项
  const announcementTypeOptions = ref([
    { label: '重要通知', value: 'important' },
    { label: '政策解读', value: 'policy' },
    { label: '园区活动', value: 'activity' },
    { label: '其他公告', value: 'other' }
  ])
  
  // 获取通知公告列表
  async function getAnnouncementList(params = {}) {
    loading.value = true
    try {
      // 合并过滤参数
      const queryParams = { ...announcementFilter.value, ...params }
      
      // 模拟API调用
      // const response = await serviceRequest.getAnnouncementList(queryParams)
      
      // 模拟数据
      const response = {
        list: [
          {
            id: '1',
            title: '关于园区安全隐患排查的通知',
            content: '为确保园区安全，将于本周五进行安全隐患排查...',
            type: 'important',
            typeName: '重要通知',
            isRead: true,
            publishTime: '2023-06-01 10:00:00'
          },
          {
            id: '2',
            title: '2023年第二季度园区活动预告',
            content: '园区将在第二季度举办多项文化活动，欢迎企业参与...',
            type: 'activity',
            typeName: '园区活动',
            isRead: false,
            publishTime: '2023-06-02 14:30:00'
          },
          {
            id: '3',
            title: '关于减免中小企业租金的政策解读',
            content: '根据最新政策，符合条件的中小企业可享受租金减免...',
            type: 'policy',
            typeName: '政策解读',
            isRead: false,
            publishTime: '2023-06-03 09:15:00'
          }
        ],
        total: 3,
        unreadCount: 2,
        page: 1,
        pageSize: 10
      }
      
      announcementList.value = response.list
      unreadCount.value = response.unreadCount
      announcementCount.value = response.total
      announcementPagination.value = {
        total: response.total,
        current: response.page,
        pageSize: response.pageSize
      }
      
      return announcementList.value
    } catch (error) {
      console.error('获取通知公告列表失败', error)
      return []
    } finally {
      loading.value = false
    }
  }
  
  // 获取通知公告详情
  async function getAnnouncementDetail(id) {
    if (!id) return null
    
    loading.value = true
    try {
      // 模拟API调用
      // const response = await serviceRequest.getAnnouncementDetail(id)
      
      // 模拟数据
      const response = {
        id: '1',
        title: '关于园区安全隐患排查的通知',
        content: '<p>为确保园区安全，将于本周五进行安全隐患排查，具体安排如下：</p><p>1. 排查时间：2023年6月9日 9:00-17:00</p><p>2. 排查范围：所有楼宇公共区域和企业办公区域</p><p>3. 注意事项：请各企业安排人员配合检查</p>',
        type: 'important',
        typeName: '重要通知',
        attachments: [
          {
            id: '1',
            name: '安全检查表.docx',
            url: 'https://example.com/uploads/safety_check.docx',
            size: 512 * 1024,
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            uploadTime: '2023-06-01 09:50:00'
          }
        ],
        publishTime: '2023-06-01 10:00:00',
        publisher: '园区管理部',
        isRead: true
      }
      
      announcementDetail.value = response
      
      // 更新列表中的已读状态
      const index = announcementList.value.findIndex(item => item.id === id)
      if (index !== -1 && !announcementList.value[index].isRead) {
        announcementList.value[index].isRead = true
        if (unreadCount.value > 0) {
          unreadCount.value--
        }
      }
      
      return announcementDetail.value
    } catch (error) {
      console.error('获取通知公告详情失败', error)
      return null
    } finally {
      loading.value = false
    }
  }
  
  // 标记通知为已读
  async function markAnnouncementAsRead(id) {
    if (!id) return false
    
    try {
      // 模拟API调用
      // const response = await serviceRequest.markAnnouncementAsRead(id)
      
      // 更新本地状态
      const index = announcementList.value.findIndex(item => item.id === id)
      if (index !== -1 && !announcementList.value[index].isRead) {
        announcementList.value[index].isRead = true
        if (unreadCount.value > 0) {
          unreadCount.value--
        }
      }
      
      return true
    } catch (error) {
      console.error('标记通知已读失败', error)
      return false
    }
  }
  
  // 获取物业报修列表
  async function getPropertyRepairList(params = {}) {
    loading.value = true
    try {
      // 模拟API调用
      // const response = await serviceRequest.getPropertyRepairList(params)
      
      // 模拟数据
      const response = {
        list: [
          {
            id: '1',
            title: '办公室灯管损坏',
            type: 'electric',
            typeName: '电力设备',
            location: 'A栋3楼305',
            status: 0,
            statusName: '待处理',
            createTime: '2023-06-01 11:20:00'
          },
          {
            id: '2',
            title: '卫生间水龙头漏水',
            type: 'water',
            typeName: '水力设备',
            location: 'B栋4楼公共卫生间',
            status: 1,
            statusName: '处理中',
            createTime: '2023-06-02 09:15:00'
          }
        ],
        total: 2,
        page: 1,
        pageSize: 10
      }
      
      propertyRepairList.value = response.list
      
      return propertyRepairList.value
    } catch (error) {
      console.error('获取物业报修列表失败', error)
      return []
    } finally {
      loading.value = false
    }
  }
  
  // 提交物业报修
  async function submitPropertyRepair(data) {
    loading.value = true
    try {
      // 模拟API调用
      // const response = await serviceRequest.submitPropertyRepair(data)
      
      // 模拟响应
      const response = {
        code: 200,
        message: '提交成功',
        data: {
          id: Math.floor(Math.random() * 1000).toString()
        }
      }
      
      return response
    } catch (error) {
      console.error('提交物业报修失败', error)
      return {
        code: 500,
        message: '提交失败',
        data: null
      }
    } finally {
      loading.value = false
    }
  }
  
  // 获取访客预约列表
  async function getVisitorAppointmentList(params = {}) {
    loading.value = true
    try {
      // 模拟API调用
      // const response = await serviceRequest.getVisitorAppointmentList(params)
      
      // 模拟数据
      const response = {
        list: [
          {
            id: '1',
            visitorName: '李四',
            visitorPhone: '13800138001',
            visitReason: '业务洽谈',
            visitTime: '2023-06-10 14:00:00',
            status: 0,
            statusName: '待审批',
            createTime: '2023-06-01 10:30:00'
          },
          {
            id: '2',
            visitorName: '王五',
            visitorPhone: '13900139002',
            visitReason: '设备维护',
            visitTime: '2023-06-11 10:00:00',
            status: 1,
            statusName: '已通过',
            createTime: '2023-06-02 09:20:00'
          }
        ],
        total: 2,
        page: 1,
        pageSize: 10
      }
      
      visitorAppointmentList.value = response.list
      
      return visitorAppointmentList.value
    } catch (error) {
      console.error('获取访客预约列表失败', error)
      return []
    } finally {
      loading.value = false
    }
  }
  
  // 提交访客预约
  async function submitVisitorAppointment(data) {
    loading.value = true
    try {
      // 模拟API调用
      // const response = await serviceRequest.submitVisitorAppointment(data)
      
      // 模拟响应
      const response = {
        code: 200,
        message: '预约成功',
        data: {
          id: Math.floor(Math.random() * 1000).toString()
        }
      }
      
      return response
    } catch (error) {
      console.error('提交访客预约失败', error)
      return {
        code: 500,
        message: '预约失败',
        data: null
      }
    } finally {
      loading.value = false
    }
  }
  
  // 获取设施预约列表
  async function getFacilityReservationList(params = {}) {
    loading.value = true
    try {
      // 模拟API调用
      // const response = await serviceRequest.getFacilityReservationList(params)
      
      // 模拟数据
      const response = {
        list: [
          {
            id: '1',
            facilityName: '会议室A',
            reservationTime: '2023-06-15 14:00:00',
            duration: 2, // 小时
            purpose: '项目讨论',
            status: 0,
            statusName: '待审批',
            createTime: '2023-06-01 11:30:00'
          },
          {
            id: '2',
            facilityName: '多功能厅',
            reservationTime: '2023-06-20 09:00:00',
            duration: 4, // 小时
            purpose: '企业培训',
            status: 1,
            statusName: '已通过',
            createTime: '2023-06-02 10:20:00'
          }
        ],
        total: 2,
        page: 1,
        pageSize: 10
      }
      
      facilityReservationList.value = response.list
      
      return facilityReservationList.value
    } catch (error) {
      console.error('获取设施预约列表失败', error)
      return []
    } finally {
      loading.value = false
    }
  }
  
  // 提交设施预约
  async function submitFacilityReservation(data) {
    loading.value = true
    try {
      // 模拟API调用
      // const response = await serviceRequest.submitFacilityReservation(data)
      
      // 模拟响应
      const response = {
        code: 200,
        message: '预约成功',
        data: {
          id: Math.floor(Math.random() * 1000).toString()
        }
      }
      
      return response
    } catch (error) {
      console.error('提交设施预约失败', error)
      return {
        code: 500,
        message: '预约失败',
        data: null
      }
    } finally {
      loading.value = false
    }
  }
  
  // 更新通知公告过滤条件
  function updateAnnouncementFilter(params) {
    announcementFilter.value = { ...announcementFilter.value, ...params }
  }
  
  // 重置通知公告过滤条件
  function resetAnnouncementFilter() {
    announcementFilter.value = {
      type: null,
      keyword: '',
      startDate: null,
      endDate: null,
      page: 1,
      pageSize: 10
    }
  }
  
  // 重置所有状态
  function resetServiceState() {
    announcementList.value = []
    announcementDetail.value = null
    propertyRepairList.value = []
    propertyRepairDetail.value = null
    visitorAppointmentList.value = []
    visitorAppointmentDetail.value = null
    facilityReservationList.value = []
    facilityReservationDetail.value = null
    resetAnnouncementFilter()
  }

  return {
    // 状态
    announcementList,
    announcementDetail,
    announcementCount,
    unreadCount,
    propertyRepairList,
    propertyRepairDetail,
    visitorAppointmentList,
    visitorAppointmentDetail,
    facilityReservationList,
    facilityReservationDetail,
    loading,
    announcementPagination,
    announcementFilter,
    announcementTypeOptions,
    
    // 方法
    getAnnouncementList,
    getAnnouncementDetail,
    markAnnouncementAsRead,
    getPropertyRepairList,
    submitPropertyRepair,
    getVisitorAppointmentList,
    submitVisitorAppointment,
    getFacilityReservationList,
    submitFacilityReservation,
    updateAnnouncementFilter,
    resetAnnouncementFilter,
    resetServiceState
  }
}, {
  persist: {
    key: 'service-store',
    storage: sessionStorage,
    paths: ['announcementFilter', 'unreadCount']
  }
}) 